module.exports = __webpack_public_path__ + "media/images/pages/home_featured/who-we-are-invest-8bcca7f5c212dd147fc0a3025a3709ee.png";